import ReactEcharts from "echarts-for-react";
import { Row, Col } from "antd";
import "./complianceAssessment.css";

const ComplianceAssessment = ({ data }) => {
  const assessmentTypes = [
    "N/A",
    "Pending",
    "Non\nCompliant",
    "Partially\nCompliant",
    "Compliant"
  ];
  // const colors = ["#D5D0C9", "black", "#EC5367", "#FF974C", "#AFDF5B"]; // initial colors
  const colors = ["#CACACA", "#00A7B5", "#ED5367", "#FF974B", "#AFDF5B"]; // figma colors

  const roundedData = data.map((score) => Math.round(score * 100) / 100) //to only keep 2 decimals

  var option = {
    width: "60%",
    title: {
      text: "Obligations Overview",
      center: "right",
      textStyle: {
        color: "#333",
        fontFamily: "Roboto",
        fontWeight: "600",
        fontSize: "1.5rem",
        marginBottom: "1.25rem"
      },
      itemGap: 25,
      padding: 20
    },
    yAxis: {
      type: "category",
      data: assessmentTypes,
      axisLabel: {
        align: "right",
        padding: [0, 0, 0, 0]
      }
    },
    xAxis: {
      type: "value",
      min: 0,
      max: 100,
      interval: 25,
      axisLabel: {
        formatter: "{value}%"
      }
    },

    grid: {
      left: "20%",
      top: "25%",
      bottom: "10%"
    },
    series: [
      {
        data: roundedData,
        type: "bar",
        itemStyle: {
          color: function (params) {
            return colors[params.dataIndex];
          }
        },
        label: {
          show: true,
          position: "right",
          formatter: "{@score}%",
        },
        // emphasis: {
        //   label: {
        //     show: true,
        //   }
        // },
      }
    ]
  };

  return (
    <div>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="complianceComp"
      >
        <Col span={24}>
          <ReactEcharts option={option} />
        </Col>
      </Row>
    </div>
  );
};

export default ComplianceAssessment;
